import { atom } from 'jotai'

export const pageState = atom('');
